import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'ceeu_mental_disclaimer_dismissed';
const HEIGHT_VAR = '--disclaimer-height';

export default function Disclaimer() {
  const { t } = useTranslation();
  const [hidden, setHidden] = useState(false);
  const boxRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setHidden(sessionStorage.getItem(STORAGE_KEY) === '1');
  }, []);

  /*
   * 画面の下に固定しているので、いちばん下の内容が隠れないように、どの画面でも高さの分だけ下を空ける（#174）。
   * 高さは画面の幅で変わるため、決まった値にせず実際の高さを読む。閉じたら空けない。
   */
  useEffect(() => {
    const box = boxRef.current;
    if (!box) return;
    const root = document.documentElement;
    const apply = () => root.style.setProperty(HEIGHT_VAR, `${box.offsetHeight}px`);
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(box);
    return () => {
      observer.disconnect();
      root.style.removeProperty(HEIGHT_VAR);
    };
  }, [hidden]);

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setHidden(true);
  };

  if (hidden) return null;

  return (
    <div className="disclaimer" role="note" aria-label="注意事項" ref={boxRef}>
      <div className="disclaimer-inner">
        <p className="disclaimer-not-medical">{t('disclaimer.notMedical')}</p>
        <p className="disclaimer-consult">{t('disclaimer.consultDoctor')}</p>
      </div>
      <button
        type="button"
        className="disclaimer-close"
        onClick={handleClose}
        aria-label="注意事項を閉じる"
      >
        ×
      </button>
    </div>
  );
}
